import { render, staticRenderFns } from "./Restituicao.vue?vue&type=template&id=5f75fd6a&scoped=true"
import script from "./Restituicao.vue?vue&type=script&lang=js"
export * from "./Restituicao.vue?vue&type=script&lang=js"
import style0 from "./Restituicao.vue?vue&type=style&index=0&id=5f75fd6a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f75fd6a",
  null
  
)

export default component.exports